import { RecordTypeEnum } from '@/enums/dialogEnum';
import { chatRequest } from './request';

// 获取聊天记录列表
export function dialoguesRecordList(data: API.DialoguesParams) {
  return chatRequest<API.DialoguesRecordItem[]>({
    url: '/api/talk/message/list',
    method: 'post',
    data: {
      ...data,
      limit: 20,
    },
  });
}

// 搜索聊天记录
export function searchDialoguesRecord(data: API.SearchDialoguesParams) {
  return chatRequest<API.PaginationData<API.DialoguesRecordItem[]>>({
    url: '/api/talk/message/search',
    method: 'post',
    data: {
      ...data,
      limit: 20,
    },
  });
}

// 发送信息
export function dialoguesSend(
  receiverId: number | undefined,
  type: RecordTypeEnum,
  content: string,
  quoteId: number | undefined,
) {
  return chatRequest<API.SessionChatInfo>({
    url: '/api/talk/message/send',
    method: 'post',
    data: {
      talk_type: 1,
      file_type: type === RecordTypeEnum.TEXT ? undefined : type,
      receiver_id: receiverId,
      text: content,
      quote_id: quoteId,
    },
  });
}

// 删除聊天记录
export function dialoguesRecordDelete(id: number) {
  return chatRequest<any>({
    url: `/api/talk/message/delete/${id}`,
    method: 'delete',
  });
}

// 获取列表
export function getUserList() {
  return chatRequest<API.DialoguesItem[]>({
    url: '/api/talk/session_chat/chat_session_list',
    method: 'post',
  });
}

// 获取详情
export function dialoguesInfo(id: number) {
  return chatRequest<API.DialoguesInfo>({
    url: `/api/talk/session_chat/detail/${id}`,
    method: 'get',
  });
}

// 设置置顶
export function dialoguesSetTop(receiverId: string, isTop: number) {
  return chatRequest<any>({
    url: `/api/talk/session_chat/setTop/${receiverId}/${isTop}`,
    method: 'post',
  });
}

// 设置已读
export function dialoguesSetRead(chatRecordId: number, isRead: number) {
  return chatRequest<any>({
    url: `/api/talk/session_chat/setRead/${chatRecordId}/${isRead}`,
    method: 'post',
  });
}

// 设置备注
export function dialoguesSetRemark(receiverId: number, remark: string) {
  return chatRequest<string>({
    url: '/api/talk/session_chat/remark',
    method: 'post',
    data: {
      receiver_id: receiverId,
      remark,
    },
  });
}

// 搜索用户
export function findAllSessionByMobile(mobile: string) {
  return chatRequest<{
    exit: API.DialoguesItem[]
    no_exit: API.DialoguesItem[]
  }>({
    url: `/api/talk/session_chat/findAllSessionChatByMobile/${mobile}`,
    method: 'get',
  });
}

// 获取会话
export function getSessionChat(receiverId: number) {
  return chatRequest<any>({
    url: `/api/talk/session_chat/getSessionChat/${receiverId}`,
    method: 'post',
  });
}

// 用户创建会话
export function userCreateSessionChat(siteId: number) {
  return chatRequest<any>({
    url: `/api/talk/session_chat/create_from_site/${siteId}`,
    method: 'post',
  });
}

// 创建和推送会话
export function createAndPushSessionChat(mobile: string) {
  return chatRequest<any>({
    url: `/api/talk/session_chat/createAndPushSessionChat/${mobile}`,
    method: 'post',
  });
}

// 获取代理信息信息
export function getDlInfo(url: string) {
  const BaseUrl = import.meta.env.VITE_SERVER_BASEURL || '';
  return chatRequest<API.DlInfo>({
    url: `${BaseUrl}/dl/getInfo`,
    method: 'post',
    data: { url },
  });
}

// 获取代理站点信息
export function getDlSiteList(siteUrl: string) {
  return chatRequest<API.SiteInfo[]>({
    url: `${siteUrl}/v1/site/getList`,
    method: 'post',
  });
}

// 会话分配
export function allocationChat(siteId: number) {
  return chatRequest<API.SiteInfo[]>({
    url: `/api/talk/session_chat/allocation`,
    method: 'post',
    data: { site_id: siteId },
  });
}

export function getWpListSite(
  siteUrl: string,
  dfType: number,
  deliverType: number,
) {
  return chatRequest<{
    [id: number]: API.SiteWpItem
  }>({
    url: `${siteUrl}/v1/dsyOrder/getWpListSite?df_type=${dfType}&deliver_type=${deliverType}`,
    method: 'get',
  });
}

export function getWpExplainV2(siteUrl: string, courierId: number) {
  return chatRequest<API.WpExplain>({
    url: `${siteUrl}/v1/logistic/getWpExplainV2?courier_id=${courierId}`,
    method: 'get',
  });
}

export function getNotice(siteId: number) {
  return chatRequest<API.SiteNotice>({
    // 站点公告正确路由（旧路径 /api/talk/session_chat/getNotice 在 PHP 端也不存在，恒 406）
    url: `/api/site/site/getSiteNotice/${siteId}`,
    method: 'get',
  });
}
